import { IRoomPeople } from './../../../core/models/roompeople';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-room-people',
    templateUrl: 'room-people.component.html'
})

export class RoomPeopleComponent implements OnInit {

    @Input() roomNumber: number;
    @Output()
    saveRoomPeople: EventEmitter<any> = new EventEmitter();

    adults = [];
    children = [];
    childrenAge = [];

    selectedChildren = 0;
    selectedAdults = 1;
    Arr = Array;

    roomPeople: IRoomPeople;
    adultNum = 'adult1';
    childrenAges;

    constructor() { }

    /*
    @TODO move this function to a utily module later DUPLICATE CODE
    */
    fillRange (size, start) {
        return Array.from(Array(size), (x, i) => (i + start));
    }

    ngOnInit() {
        this.childrenAges = new Array<string>();
        this.initAdultsNum();
        this.initChildrenNum();
        this.initChildrenAge();
    }

    initAdultsNum() {
        this.adults = this.fillRange(20, 1);
      }

      initChildrenNum() {
        this.children = this.fillRange(7, 0);
      }

      initChildrenAge() {
        this.childrenAge.push('<1');
        this.childrenAge = this.childrenAge.concat(this.fillRange(17, 1));
      }

      isChildrenSelected() {
          if (this.selectedChildren > 0) {
              return true;
          }
          return false;
      }

      setChildAge(age, index) {
        this.childrenAges[index] = age.split('e').pop();
        this.setRoomNumber();
      }

      setAdultsNumber(adultNum) {

        this.selectedAdults = parseInt(adultNum.split('d').pop(), 10);
        this.setRoomNumber();
      }

      setChildrenNumber(childNum) {
        this.selectedChildren = parseInt(childNum.split('d').pop(), 10);
        const childrenSize = this.selectedChildren - this.childrenAges.length;
        if (this.selectedChildren > this.childrenAges.length) {
            for (let i = 0; i < childrenSize; i++) {
                this.childrenAges.push('<1');
            }
        } else if (this.selectedChildren < this.childrenAges.length) {
            for (let i = this.childrenAges.length - 1; i >= this.selectedChildren; i--) {
                this.childrenAges.pop();
            }
        }
        this.setRoomNumber();
      }

      setRoomNumber() {
        this.roomPeople = {
            adults: parseInt(this.adultNum.split('t').pop(), 10),
            children: this.childrenAges
        };
        this.saveRoomPeople.emit([this.roomNumber, this.roomPeople]);
      }

}

